
define('text!application/modules/vkb/vkb.html',[],function () { return '<oms-virtual-keyboard-keyboard id="oms-vkb"></oms-virtual-keyboard-keyboard>';});

